export const AuthenticationPaths = {
  root: 'authentication',
  children: {
    login: {
      path: 'login',
    },
    callback: {
      path: 'callback',
    },
    welcome: {
      path: 'welcome',
    },
    signUp: {
      path: 'sign-up',
    },
    confirmEmailSent: {
      path: 'confirm-email-sent',
    },
    confirmEmail: {
      path: 'confirm-email',
    },
    confirmPhone: {
      path: 'confirm-phone',
    },
    corporateInfo: {
      path: 'corporate-info',
    },
    chooseCountry: {
      path: 'choose-country',
    },
  },
};
